import React from 'react';

interface IconLinkValueProps {
  value: {
    iconPosition: 'right' | 'left';
    icon: string;
    className?: string;
    type?: 'full' | 'half' | 'empty';
  };
}

const Icon: React.FC<IconLinkValueProps> = ({ value }) => {
  const { iconPosition, icon, className, type } = value;

  const fillValue = type === 'full' ? 1 : 0; 

  const iconStyles = {
    fontVariationSettings: `'FILL' ${fillValue}`
  };

  return (
    <div className={`flex items-center ${iconPosition === 'right' ? 'flex-row-reverse space-x-reverse justify-end' : 'flex-row'} space-x-2`}>
      <span
        style={iconStyles}
        className={`material-symbols-outlined text-2xl ${className}`}
      >
        {icon}
      </span>
    </div>
  );
};

export default Icon;
